export default __webpack_public_path__ + "static/media/190629_190332_IMG_4519.92b40423.jpg";